import { Tooltip, TooltipContent, TooltipTrigger } from '@predoc/cow';
import { cn } from '@/lib/utils';

interface TruncatedTextProps {
  text: string;
  className?: string;
  tooltipClassName?: string;
  tooltipSide?: 'top' | 'bottom' | 'left' | 'right';
}

export const TruncatedText = ({
  text,
  className,
  tooltipClassName,
  tooltipSide = 'top',
}: TruncatedTextProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn('block min-w-0 truncate', className)}>{text}</span>
      </TooltipTrigger>
      <TooltipContent
        side={tooltipSide}
        className={cn('max-w-[480px]', tooltipClassName)}
      >
        {text}
      </TooltipContent>
    </Tooltip>
  );
};
